import {
  designType,
  designShell,
  pageHeaderRow,
  rowsPerPageOptions,
  rowsPerPageControl as sharedRowsPerPageControl,
  paginationFooter as sharedPaginationFooter,
  APP_BAR_OFFSET,
  HEADER_ACTION_BUTTON_WIDTH,
} from "services/constants/designTokens";
import { themes } from "services/constants";

export { APP_BAR_OFFSET };

export const createAdminListUi = ({
  primaryButtonMinWidth,
  selectedRow,
}) => ({
  page: {
    width: "100%",
  },
  headerRow: {
    ...designShell.headerRowBase,
    alignItems: { xs: "flex-start", sm: "center" },
    mb: 2,
  },
  title: designType.pageTitle,
  subtitle: designType.pageSubtitle,
  primaryButton: {
    ...designShell.primaryButtonBase,
    minWidth: primaryButtonMinWidth,
  },
  sectionCard: designShell.sectionCard,
  tableCard: designShell.tableCard,
  tableHeadCell: {
    ...designShell.tableHeadCellBase,
    py: 0.75,
    position: "sticky",
    top: APP_BAR_OFFSET,
    zIndex: 2,
  },
  stickyCustomFilterBar: {
    position: "sticky",
    top: APP_BAR_OFFSET,
    zIndex: 4,
    backgroundColor: "#FFFFFF",
  },
  stickyFooterBar: {
    position: "sticky",
    bottom: 0,
    zIndex: 3,
    px: 2,
    py: 0.75,
    borderTop: "1px solid #E2E8F0",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 -10px 24px rgba(15, 23, 42, 0.06)",
  },
  tableBodyCell: {
    py: 0.75,
    fontSize: 14,
    color: "#0F172A",
    borderBottom: "1px solid #E2E8F0",
    // Cells with plain text (email, phone, GST no., etc.) render straight
    // off `data[head.key]` with no truncation of their own, so under the
    // table's fixed column layout a long value visually bled into the next
    // column instead of the table growing to fit it. Clipping at the cell
    // is the fixed-layout counterpart to that.
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  selectedRow,
  mutedFaint: {
    color: "#94A3B8",
  },
  fieldLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#64748B",
  },
  fieldValue: {
    fontSize: 14,
    fontWeight: 500,
    color: "#0F172A",
  },
  panelTitle: designType.panelTitle,
  panelSectionTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: "#0F172A",
  },
  panelMutedText: {
    fontSize: 13,
    color: "#64748B",
  },
  rowsPerPageSelect: designShell.rowsPerPageSelect,
  paginationIconButton: designShell.paginationIconButton,
});

export const createAdminHeaderRow = ({
  title,
  subtitle,
  primaryLabel,
  onPrimaryClick,
  primaryButtonMinWidth,
  sx,
  showPrimaryAction,
}) =>
  pageHeaderRow({
    title,
    subtitle,
    primaryLabel,
    onPrimaryClick,
    primaryButtonSx: { minWidth: primaryButtonMinWidth },
    sx,
    showPrimaryAction,
  });

export const adminUi = createAdminListUi({
  primaryButtonMinWidth: HEADER_ACTION_BUTTON_WIDTH,
  selectedRow: designShell.neutralSelectedRow,
});

adminUi.page = {
  ...adminUi.page,
  ...designShell.pageSurface,
};

export const companyUi = createAdminListUi({
  primaryButtonMinWidth: HEADER_ACTION_BUTTON_WIDTH,
  selectedRow: designShell.accentSelectedRow,
});

companyUi.page = {
  ...companyUi.page,
  ...designShell.pageSurface,
};

export const rowsPerPageControl = (args) => sharedRowsPerPageControl(args);

export const paginationFooter = ({
  rowsPerPageOptions: options = rowsPerPageOptions,
  ...rest
}) => sharedPaginationFooter({ ...rest, rowsPerPageOptions: options });

export const usersHeaderRow = ({
  title,
  subtitle,
  primaryLabel,
  onPrimaryClick,
  showPrimaryAction,
}) =>
  createAdminHeaderRow({
    title,
    subtitle,
    primaryLabel,
    onPrimaryClick,
    primaryButtonMinWidth: HEADER_ACTION_BUTTON_WIDTH,
    sx: adminUi.headerRow,
    showPrimaryAction,
  });

export const companiesHeaderRow = ({
  title,
  subtitle,
  primaryLabel,
  onPrimaryClick,
  showPrimaryAction,
}) =>
  createAdminHeaderRow({
    title,
    subtitle,
    primaryLabel,
    onPrimaryClick,
    primaryButtonMinWidth: HEADER_ACTION_BUTTON_WIDTH,
    sx: companyUi.headerRow,
    showPrimaryAction,
  });
